export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/dancehall.4ae68b1.svg";